import { z } from 'zod';

export const feedbackMessageInputSchema = z.object({
  body: z
    .string()
    .trim()
    .min(1, '本文を入力してください')
    .max(2000, '本文は2000文字以内'),
});

export type FeedbackMessageInputSchema = z.infer<typeof feedbackMessageInputSchema>;
